/**
 * CargaKarcher
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {CargaKarcherCollection} from '@/model/collection/CargaKarcherCollection'

/* TODO: review generated class */
export class CargaKarcher extends Resource {
  idCargaInfoPk: number = 0

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  nomeArquivo: string | null = null
  dataInicioDownload: string | null = null

  get $id() {
    return this.idCargaInfoPk
  }
  set $id(val) {
    this.idCargaInfoPk = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of CargaKarcher
   */
  async getCargaKarcher(id: number) {
    return await Request.get(`/admin/carga-karcher/${id}`)
      .name('getCargaKarcher')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CargaKarcher
   */
  static async listCargaKarcher(params: any) {
    return await Request.get(`/admin/carga-karcher`, {params})
      .name('listCargaKarcher')
      .as(CargaKarcherCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaKarcher. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaKarcher() {
    return await Request.post(`/admin/carga-karcher`, this)
      .name('persistCargaKarcher')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaKarcher to use it in a CSV file
   */
  static async listCsvCargaKarcher(params: any) {
    return await Request.get(`/admin/carga-karcher/csv`, {params})
      .name('listCsvCargaKarcher')
      .as(CargaKarcherCollection)
      .getData()
  }
}
